/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveRetrievePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveRetrieveQueryRefreshSchema = z
	.boolean()
	.optional()
	.describe(
		"Спросить кассу о текущем состоянии брони перед ответом: статус, состав и оплаты банкета будут актуальными на момент запроса. Нужно перед изменением состава.",
	);

export const orgUnitReserveRetrievePathReserveIdSchema = z.uuid();

export const orgUnitReserveRetrieveStatus200Schema = reserveSchema;

export const orgUnitReserveRetrieveResponseSchema = orgUnitReserveRetrieveStatus200Schema;
